module.exports = __webpack_public_path__ + "static/media/diagram.946638e5.png";